import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, useGLTF } from '@react-three/drei';

function FemaleAvatar() {
  const { scene } = useGLTF('/Avatars/female.glb'); // Ensure the correct path to your female avatar .glb file

  return (
    <Canvas 
      camera={{ position: [0, 3, 8], fov: 70 }}  // Move the camera back and up
      style={{ width: '100%', height: '100%' }}
    >
      <ambientLight intensity={0.5} />
      <directionalLight position={[10, 10, 10]} intensity={1} />
      <Suspense fallback={null}>
        <primitive 
          object={scene} 
          scale={8.5} 
          position={[1, -9, -3]}  // Move the model up to align with the camera
        /> 
      </Suspense>
      <OrbitControls 
        enableZoom={true} 
        minDistance={5}  // Set minimum distance to avoid zooming in too close
        maxDistance={20} // Adjust max distance to allow some zoom out
        target={[0, 1, 0]}  // Center the orbit controls on the model's torso
      />
    </Canvas>
  );
}

export default FemaleAvatar;
